module.exports = __webpack_public_path__ + "img/hockey.4bc0bfd8.svg";